var map = {
	"./de-DE.svg": "PC1F",
	"./en-US.svg": "AeAd",
	"./es-ES.svg": "W8AD",
	"./fr-FR.svg": "wSrN",
	"./ja-JP.svg": "6bsz",
	"./ko-KR.svg": "+DtT",
	"./ru-RU.svg": "ESQz",
	"./zh-CN.svg": "Ry/7",
	"./zh-TW.svg": "X5bQ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XewS";